// Curated trip lists for the homepage category carousels.
// Each trip card includes everything needed to render: image, title,
// duration, route, summary, tag and destination route id.
//
// Tag pill colors follow the brand palette per category.

const T = (es, en, fr) => ({ es, en, fr });

/* ===== Sur de Marruecos ===== */
export const SOUTH_TRIPS = [
  {
    id: "atlas-desierto-6n",
    routeId: "tourAtlasDesierto67",
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1600&q=85",
    duration: T("6 noches · 7 días", "6 nights · 7 days", "6 nuits · 7 jours"),
    title: T("Ouarzazate · Atlas · Erg Chebbi",
             "Ouarzazate · Atlas · Erg Chebbi",
             "Ouarzazate · Atlas · Erg Chebbi"),
    route: T("Ouarzazate → Dades → Erg Chebbi → Errachidia",
             "Ouarzazate → Dades → Erg Chebbi → Errachidia",
             "Ouarzazate → Dadès → Erg Chebbi → Errachidia"),
    summary: T("Travesía del Alto Atlas hacia las grandes dunas del Erg Chebbi, con noches en kasbah y bivouac de lujo.",
               "High Atlas crossing toward the great Erg Chebbi dunes, with kasbah nights and a luxury bivouac.",
               "Traversée du Haut Atlas vers les grandes dunes de l'Erg Chebbi, nuits en kasbah et bivouac de luxe."),
    tag: T("Atlas & Sahara", "Atlas & Sahara", "Atlas & Sahara"),
  },
  {
    id: "atlas-desierto-5n",
    routeId: "tourAtlasDesierto56",
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=85",
    duration: T("5 noches · 6 días", "5 nights · 6 days", "5 nuits · 6 jours"),
    title: T("Atlas · Desierto · Errachidia",
             "Atlas · Desert · Errachidia",
             "Atlas · Désert · Errachidia"),
    route: T("Ouarzazate → Atlas → Erg Chebbi",
             "Ouarzazate → Atlas → Erg Chebbi",
             "Ouarzazate → Atlas → Erg Chebbi"),
    summary: T("Una semana entre kasbahs, valles del Atlas y noche bajo las estrellas del Sahara.",
               "A week between kasbahs, Atlas valleys and a night under Saharan stars.",
               "Une semaine entre kasbahs, vallées de l'Atlas et nuit sous les étoiles du Sahara."),
    tag: T("Desierto", "Desert", "Désert"),
  },
  {
    id: "marrakech-fez-7n",
    routeId: "tourMarrakechFez78",
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1600&q=85",
    duration: T("7 noches · 8 días", "7 nights · 8 days", "7 nuits · 8 jours"),
    title: T("Marrakech · Atlas · Erg Chebbi · Fez",
             "Marrakech · Atlas · Erg Chebbi · Fez",
             "Marrakech · Atlas · Erg Chebbi · Fès"),
    route: T("Marrakech → Aït Ben Haddou → Dades → Erg Chebbi → Fez",
             "Marrakech → Aït Ben Haddou → Dades → Erg Chebbi → Fez",
             "Marrakech → Aït Ben Haddou → Dadès → Erg Chebbi → Fès"),
    summary: T("La gran travesía del sur: ciudades imperiales, montañas y dunas en un solo viaje.",
               "The grand south crossing: imperial cities, mountains and dunes in one trip.",
               "La grande traversée du sud : cités impériales, montagnes et dunes."),
    tag: T("Gran travesía", "Grand crossing", "Grande traversée"),
  },
  {
    id: "marrakech-fez-9n",
    routeId: "tourMarrakechFez910",
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1600&q=85",
    duration: T("9 noches · 10 días", "9 nights · 10 days", "9 nuits · 10 jours"),
    title: T("Marrakech · Sahara · Fez — Ruta extendida",
             "Marrakech · Sahara · Fez — Extended route",
             "Marrakech · Sahara · Fès — Itinéraire prolongé"),
    route: T("Marrakech → Atlas → Sahara → Volubilis → Fez",
             "Marrakech → Atlas → Sahara → Volubilis → Fez",
             "Marrakech → Atlas → Sahara → Volubilis → Fès"),
    summary: T("Diez días para vivirlo todo: medinas, oasis, gargantas y noches en el desierto.",
               "Ten days to live it all: medinas, oases, gorges and desert nights.",
               "Dix jours pour tout vivre : médinas, oasis, gorges et nuits dans le désert."),
    tag: T("10 días", "10 days", "10 jours"),
  },
  {
    id: "desierto-atlas-5n",
    routeId: "tourDesiertoAtlas56",
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    duration: T("5 noches · 6 días", "5 nights · 6 days", "5 nuits · 6 jours"),
    title: T("Errachidia → Atlas (sentido inverso)",
             "Errachidia → Atlas (reverse direction)",
             "Errachidia → Atlas (sens inverse)"),
    route: T("Errachidia → Erg Chebbi → Todra → Atlas → Ouarzazate",
             "Errachidia → Erg Chebbi → Todra → Atlas → Ouarzazate",
             "Errachidia → Erg Chebbi → Todra → Atlas → Ouarzazate"),
    summary: T("Vuelo a Errachidia y retorno por el Atlas — la entrada más cercana al Sahara.",
               "Fly into Errachidia and return through the Atlas — the closest entry to the Sahara.",
               "Vol vers Errachidia et retour par l'Atlas — l'accès le plus proche du Sahara."),
    tag: T("Sahara directo", "Sahara direct", "Sahara direct"),
  },
];

/* ===== Marruecos de norte a sur (grandes travesías) ===== */
export const FULL_TRIPS = [
  {
    id: "fez-marrakech-9n",
    routeId: "tourFezRak910",
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    duration: T("9 noches · 10 días", "9 nights · 10 days", "9 nuits · 10 jours"),
    title: T("Fez · Atlas · Erg Chebbi · Marrakech",
             "Fez · Atlas · Erg Chebbi · Marrakech",
             "Fès · Atlas · Erg Chebbi · Marrakech"),
    route: T("Fez → Medio Atlas → Erg Chebbi → Todra → Ouarzazate → Marrakech",
             "Fez → Middle Atlas → Erg Chebbi → Todra → Ouarzazate → Marrakech",
             "Fès → Moyen Atlas → Erg Chebbi → Todra → Ouarzazate → Marrakech"),
    summary: T("La gran travesía clásica del sur, entre las dos ciudades imperiales más fascinantes.",
               "The classic grand south crossing, between the two most fascinating imperial cities.",
               "La grande traversée classique du sud, entre les deux cités impériales les plus fascinantes."),
    tag: T("Gran travesía", "Grand crossing", "Grande traversée"),
  },
  {
    id: "marrakech-fez-8n",
    routeId: "tourMarrakechFez89",
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1600&q=85",
    duration: T("8 noches · 9 días", "8 nights · 9 days", "8 nuits · 9 jours"),
    title: T("Marrakech a Fez por el Medio Atlas",
             "Marrakech to Fez via Middle Atlas",
             "Marrakech à Fès par le Moyen Atlas"),
    route: T("Marrakech → Dades → Erg Chebbi → Medio Atlas → Fez",
             "Marrakech → Dades → Erg Chebbi → Middle Atlas → Fez",
             "Marrakech → Dadès → Erg Chebbi → Moyen Atlas → Fès"),
    summary: T("Travesía equilibrada: dunas, gargantas, cedros y la grandeza de Fez al final.",
               "A balanced crossing: dunes, gorges, cedars and Fez's grandeur at the end.",
               "Traversée équilibrée : dunes, gorges, cèdres et la grandeur de Fès en final."),
    tag: T("9 días", "9 days", "9 jours"),
  },
  {
    id: "marrakech-fez-7n-full",
    routeId: "tourMarrakechFez78",
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1600&q=85",
    duration: T("7 noches · 8 días", "7 nights · 8 days", "7 nuits · 8 jours"),
    title: T("Marrakech → Sahara → Fez",
             "Marrakech → Sahara → Fez",
             "Marrakech → Sahara → Fès"),
    route: T("Marrakech → Atlas → Sahara → Fez",
             "Marrakech → Atlas → Sahara → Fez",
             "Marrakech → Atlas → Sahara → Fès"),
    summary: T("La ruta más demandada: 8 días para conocer las dos caras imperiales del país.",
               "The most popular route: 8 days to discover Morocco's two imperial faces.",
               "L'itinéraire le plus demandé : 8 jours pour découvrir les deux faces impériales du Maroc."),
    tag: T("8 días", "8 days", "8 jours"),
  },
  {
    id: "marrakech-fez-6n",
    routeId: "tourMarrakechFez67",
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=85",
    duration: T("6 noches · 7 días", "6 nights · 7 days", "6 nuits · 7 jours"),
    title: T("Marrakech → Fez · Ruta compacta",
             "Marrakech → Fez · Compact route",
             "Marrakech → Fès · Itinéraire compact"),
    route: T("Marrakech → Dades → Erg Chebbi → Fez",
             "Marrakech → Dades → Erg Chebbi → Fez",
             "Marrakech → Dadès → Erg Chebbi → Fès"),
    summary: T("Una semana intensa de medinas, kasbahs y dunas — sin perder el ritmo del país.",
               "An intense week of medinas, kasbahs and dunes — without losing the country's rhythm.",
               "Une semaine intense de médinas, kasbahs et dunes — sans perdre le rythme du pays."),
    tag: T("7 días", "7 days", "7 jours"),
  },
  {
    id: "tanger-marrakech",
    routeId: "tourGransurTangerRak",
    image: "https://images.unsplash.com/photo-1519594445471-0e5f86b3fb09?auto=format&fit=crop&w=1600&q=85",
    duration: T("Multiples duraciones", "Multiple durations", "Plusieurs durées"),
    title: T("Tánger · Chefchaouen · Fez · Sahara · Marrakech",
             "Tangier · Chefchaouen · Fez · Sahara · Marrakech",
             "Tanger · Chefchaouen · Fès · Sahara · Marrakech"),
    route: T("Tánger → Chefchaouen → Fez → Erg Chebbi → Marrakech",
             "Tangier → Chefchaouen → Fez → Erg Chebbi → Marrakech",
             "Tanger → Chefchaouen → Fès → Erg Chebbi → Marrakech"),
    summary: T("De norte a sur sin atajos — Marruecos completo, del Mediterráneo a las dunas.",
               "North to south without shortcuts — full Morocco, from Mediterranean to dunes.",
               "Du nord au sud sans raccourcis — le Maroc complet, de la Méditerranée aux dunes."),
    tag: T("Cross-country", "Cross-country", "Cross-country"),
  },
];

/* ===== Escapadas cortas ===== */
export const SHORT_TRIPS = [
  {
    id: "escapada-desierto-3n",
    routeId: "tourEscapadaDesierto34",
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1600&q=85",
    duration: T("3 noches · 4 días", "3 nights · 4 days", "3 nuits · 4 jours"),
    title: T("Escapada al Erg Chebbi",
             "Erg Chebbi escape",
             "Escapade à l'Erg Chebbi"),
    route: T("Errachidia → Erg Chebbi → Rissani",
             "Errachidia → Erg Chebbi → Rissani",
             "Errachidia → Erg Chebbi → Rissani"),
    summary: T("Una inmersión exprés en el Sahara con bivouac de lujo y música Gnawa en Khamlia.",
               "A quick Sahara immersion with luxury bivouac and Gnawa music in Khamlia.",
               "Immersion express dans le Sahara avec bivouac de luxe et musique Gnawa à Khamlia."),
    tag: T("Desierto", "Desert", "Désert"),
  },
  {
    id: "escapada-atlas-3n",
    routeId: "tourEscapadaAtlas34",
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1600&q=85",
    duration: T("3 noches · 4 días", "3 nights · 4 days", "3 nuits · 4 jours"),
    title: T("Escapada al Alto Atlas",
             "High Atlas escape",
             "Escapade au Haut Atlas"),
    route: T("Marrakech → Imlil → Valle de Ourika",
             "Marrakech → Imlil → Ourika Valley",
             "Marrakech → Imlil → Vallée de l'Ourika"),
    summary: T("Caminatas bereberes, té con vistas y dos noches en una guesthouse de montaña.",
               "Berber walks, tea with views and two nights at a mountain guesthouse.",
               "Marches berbères, thé avec vue et deux nuits en guesthouse de montagne."),
    tag: T("Atlas", "Atlas", "Atlas"),
  },
  {
    id: "escapada-fez",
    routeId: "tourEscapadaFez",
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    duration: T("3 noches · 4 días", "3 nights · 4 days", "3 nuits · 4 jours"),
    title: T("Escapada a Fez",
             "Fez escape",
             "Escapade à Fès"),
    route: T("Fez · Medina · Volubilis · Meknes",
             "Fez · Medina · Volubilis · Meknes",
             "Fès · Médina · Volubilis · Meknès"),
    summary: T("Inmersión total en la medina más viva del país, con riad y guía local.",
               "Total immersion in the country's most alive medina, with riad and local guide.",
               "Immersion totale dans la médina la plus vivante du pays, avec riad et guide local."),
    tag: T("Imperial", "Imperial", "Impérial"),
  },
  {
    id: "escapada-marrakech",
    routeId: "tourEscapadaMarrakech",
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1600&q=85",
    duration: T("3 noches · 4 días", "3 nights · 4 days", "3 nuits · 4 jours"),
    title: T("Escapada a Marrakech",
             "Marrakech escape",
             "Escapade à Marrakech"),
    route: T("Marrakech · Medina · Jardines · Atlas",
             "Marrakech · Medina · Gardens · Atlas",
             "Marrakech · Médina · Jardins · Atlas"),
    summary: T("Riad de diseño, Jemaa el-Fna al atardecer y excursión a las cumbres del Atlas.",
               "Design riad, sunset at Jemaa el-Fna and a day trip to the Atlas summits.",
               "Riad design, coucher de soleil à Jemaa el-Fna et excursion vers les sommets de l'Atlas."),
    tag: T("Ciudad", "City", "Ville"),
  },
  {
    id: "escapada-tanger",
    routeId: "tourEscapadaTanger",
    image: "https://images.unsplash.com/photo-1519594445471-0e5f86b3fb09?auto=format&fit=crop&w=1600&q=85",
    duration: T("3 noches · 4 días", "3 nights · 4 days", "3 nuits · 4 jours"),
    title: T("Escapada a Tánger",
             "Tangier escape",
             "Escapade à Tanger"),
    route: T("Tánger · Cap Espartel · Chefchaouen",
             "Tangier · Cape Spartel · Chefchaouen",
             "Tanger · Cap Spartel · Chefchaouen"),
    summary: T("La puerta norte de África, con vistas a Europa y excursión a la ciudad azul.",
               "Africa's northern gate, with views toward Europe and a trip to the blue city.",
               "La porte nord de l'Afrique, vues sur l'Europe et virée à la ville bleue."),
    tag: T("Norte", "North", "Nord"),
  },
];

/* ===== Norte de Marruecos ===== */
export const NORTH_TRIPS = [
  {
    id: "ciudades-imperiales-4n",
    routeId: "tourCiudadesImperiales45",
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    duration: T("4 noches · 5 días", "4 nights · 5 days", "4 nuits · 5 jours"),
    title: T("Ciudades imperiales · Fez · Meknes · Volubilis",
             "Imperial cities · Fez · Meknes · Volubilis",
             "Cités impériales · Fès · Meknès · Volubilis"),
    route: T("Fez → Meknes → Volubilis → Fez",
             "Fez → Meknes → Volubilis → Fez",
             "Fès → Meknès → Volubilis → Fès"),
    summary: T("El triángulo imperial completo en 5 días, con riad de carácter en el corazón de la medina.",
               "The full imperial triangle in 5 days, with a character riad in the heart of the medina.",
               "Le triangle impérial en 5 jours, riad de caractère au cœur de la médina."),
    tag: T("Imperial", "Imperial", "Impérial"),
  },
  {
    id: "imperiales-rif-6n",
    routeId: "tourCiudadesImperialesRif67",
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1600&q=85",
    duration: T("6 noches · 7 días", "6 nights · 7 days", "6 nuits · 7 jours"),
    title: T("Ciudades imperiales & Rif",
             "Imperial cities & Rif",
             "Cités impériales & Rif"),
    route: T("Fez → Meknes → Volubilis → Chefchaouen → Tánger",
             "Fez → Meknes → Volubilis → Chefchaouen → Tangier",
             "Fès → Meknès → Volubilis → Chefchaouen → Tanger"),
    summary: T("Patrimonio romano, medinas medievales y la ciudad azul del Rif en una sola ruta.",
               "Roman heritage, medieval medinas and the blue Rif city in a single route.",
               "Patrimoine romain, médinas médiévales et la ville bleue du Rif."),
    tag: T("Imperial & Rif", "Imperial & Rif", "Impérial & Rif"),
  },
  {
    id: "tanger-fez-4n",
    routeId: "tourTangerFez45",
    image: "https://images.unsplash.com/photo-1519594445471-0e5f86b3fb09?auto=format&fit=crop&w=1600&q=85",
    duration: T("4 noches · 5 días", "4 nights · 5 days", "4 nuits · 5 jours"),
    title: T("Tánger · Chefchaouen · Fez",
             "Tangier · Chefchaouen · Fez",
             "Tanger · Chefchaouen · Fès"),
    route: T("Tánger → Chefchaouen → Akchour → Fez",
             "Tangier → Chefchaouen → Akchour → Fez",
             "Tanger → Chefchaouen → Akchour → Fès"),
    summary: T("Del estrecho a la medina más laberíntica del país, atravesando el Rif azul.",
               "From the strait to the country's most labyrinthine medina, through the blue Rif.",
               "Du détroit à la médina la plus labyrinthique du pays, à travers le Rif bleu."),
    tag: T("Norte azul", "Blue north", "Nord bleu"),
  },
  {
    id: "tanger-fez-5n",
    routeId: "tourTangerFez56",
    image: "https://images.unsplash.com/photo-1519594445471-0e5f86b3fb09?auto=format&fit=crop&w=1600&q=85",
    duration: T("5 noches · 6 días", "5 nights · 6 days", "5 nuits · 6 jours"),
    title: T("Tánger · Chefchaouen · Fez extendido",
             "Tangier · Chefchaouen · Fez extended",
             "Tanger · Chefchaouen · Fès prolongé"),
    route: T("Tánger → Tetuán → Chefchaouen → Volubilis → Fez",
             "Tangier → Tétouan → Chefchaouen → Volubilis → Fez",
             "Tanger → Tétouan → Chefchaouen → Volubilis → Fès"),
    summary: T("Una semana entre el Mediterráneo, el Rif y las ciudades imperiales del norte.",
               "A week between the Mediterranean, the Rif and the northern imperial cities.",
               "Une semaine entre Méditerranée, Rif et cités impériales du nord."),
    tag: T("6 días", "6 days", "6 jours"),
  },
  {
    id: "fez-tanger-6n",
    routeId: "tourFezTanger67",
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?auto=format&fit=crop&w=1600&q=85",
    duration: T("6 noches · 7 días", "6 nights · 7 days", "6 nuits · 7 jours"),
    title: T("Fez → Tánger (sentido inverso)",
             "Fez → Tangier (reverse)",
             "Fès → Tanger (sens inverse)"),
    route: T("Fez → Volubilis → Chefchaouen → Tetuán → Tánger",
             "Fez → Volubilis → Chefchaouen → Tétouan → Tangier",
             "Fès → Volubilis → Chefchaouen → Tétouan → Tanger"),
    summary: T("Si quieres terminar viendo el estrecho desde el Cabo Espartel — esta es tu ruta.",
               "If you want to end gazing at the strait from Cape Spartel — this is your route.",
               "Pour finir face au détroit depuis le cap Spartel — c'est votre itinéraire."),
    tag: T("7 días", "7 days", "7 jours"),
  },
];

/* ===== Próximas salidas (group departures) =====
   Cards built from UPCOMING_DEPARTURES with extra fields.        */
import { UPCOMING_DEPARTURES } from "@/lib/upcomingDepartures";

export const UPCOMING_TRIPS = UPCOMING_DEPARTURES.map((d) => ({
  id: d.id,
  routeId: "upcomingDepartures",
  image: d.image,
  duration: d.nights,
  title: d.title,
  route: d.route,
  summary: {
    es: d.highlights.es.slice(0, 2).join(" · "),
    en: d.highlights.en.slice(0, 2).join(" · "),
    fr: d.highlights.fr.slice(0, 2).join(" · "),
  },
  tag: d.badge,
  accent: d.badgeColor,
  // departure-specific fields
  dates: d.dates,
  spots: d.spots,
  capacity: d.capacity,
  price: d.price,
  status: d.status,
}));
